import { OrderTypeEnum } from "@/enums/"
import { 
    IAvailablePromotionsDTO, 
    INewOrder, IPromotionDTO, 
    OrderModificationDTO, 
    OrderType 
} from "@/interface"
import { AvailableOption } from "@/models/products/option-by-product"
import { PromotionByProductCustomer } from "@/models/promotion/promotion-by-product-customer"

export class OrderModification {

    constructor(base?: Partial<OrderModificationDTO[]>){
        if(base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: OrderModificationDTO[]) {
        enum ConfigType {
            OLD_CONFIG = 'old_config',
            NEW_CONFIG = 'new_config'
        }
        const getOrderModifier = (config: ConfigType) => {
            const getProduct = dto.find(item => item.order_type === OrderTypeEnum.PRODUCT);

            const isOptions = config === ConfigType.NEW_CONFIG ?
                dto.filter(item => item.order_type === OrderTypeEnum.OPTION).some(element => element[config]?.option) :
                getProduct ? !!getProduct[ConfigType.OLD_CONFIG].options : false;

            let promotions = {} as PromotionByProductCustomer;
            let product = {} as OrderType | null;
            let optionDataUnique = [] as (AvailableOption | null)[] ;
            let optionsOther = [] as AvailableOption[];
            const currentOptions: { [key: number]: number } = {};

            if(getProduct) {
                product = getProduct[config]?.product || null;
                promotions = new PromotionByProductCustomer({
                    productId:product?.id,
                    productName:product?.name,
                    promotions: getProduct[config]?.promotions?.map(promo => {
                        return {
                            activation_date: new Date().toString(),
                            deactivation_date: null,
                            product_id: product?.id,
                            promotion: promo as IPromotionDTO | unknown
                        } as IAvailablePromotionsDTO
                    }),
                    totals:getProduct[config]?.totals
                });
            }
            if(isOptions) {
                const optionHistory = config === ConfigType.NEW_CONFIG ?
                    dto.filter(item => item.order_type === OrderTypeEnum.OPTION).map(history => history.new_config.option ) :
                    getProduct ? getProduct[ConfigType.OLD_CONFIG].options : null;

                const optionData = optionHistory?.map(option => {

                    if (!option || !option?.name.includes("GB")) {
                        return;
                    }

                    if(Object.keys(currentOptions).includes(option.id.toString())) {
                        currentOptions[option.id] = currentOptions[option.id] + 1;
                    } else {
                        currentOptions[option.id] = 1;
                    }
                    return AvailableOption.fromOrderType(option);
                }) as AvailableOption[];

                optionsOther =
                    optionHistory?.filter(
                        item => !item?.name.includes("GB")
                    )?.map(
                        item => AvailableOption.fromOrderType(item)
                    ) as AvailableOption[];

                optionsOther.map((item: AvailableOption) => item.currentActiveOption = true);

                optionDataUnique = Object.keys(currentOptions).map(item => {
                    const option = optionData.find(option => !!option && option.id === +item);
                    if(!option) {
                        return null;
                    }
                    option.currentActiveOption = currentOptions[+item];
                    return option;
                });
            }

           return new INewOrder({
               id: product?.id,
               descriptions: product?.descriptions,
               name: product?.name,
               guid: product?.guid,
               promo: promotions as PromotionByProductCustomer,
               pricing: product?.pricing,
               optionsData: optionDataUnique ? optionDataUnique.sort((a: AvailableOption | null , b: AvailableOption | null) => {
                   if (a && b) {
                       return b.price - a.price
                   }
                   return 0
               }) as AvailableOption[] : [] as AvailableOption[],
               optionsOther: optionsOther as AvailableOption[]
           });
        }

        return {
            new: getOrderModifier(ConfigType.NEW_CONFIG),
            old: getOrderModifier(ConfigType.OLD_CONFIG)
        };
    }
}
